<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
          <ul>
            <li> The company provides vehicles for business use to allow employees to drive on company-designated
            business according to the guidelines below. The company retains the right to amend or terminate this
            policy at any time. </li>
            <li> Employees may not drive any business vehicles without prior approval of their supervisor. Prior to
            approving a driver and periodically thereafter, supervisors must check the employee's driving record. Employees
            approved to drive on company business are required to inform their supervisor of any changes that may affect either
            their legal or physical ability to drive of their continued insurability. Report changes to your driver's privileges;
            such as a ticket or a driver's license suspension, immediately. </li>
            <li> Employees holding jobs requiring regular driving for business as an essential job function must, as a condition
            of employment, be able to meet the driver approval standards of this policy at all times. </li>
            <li> Employees who drive a vehicle on company business must, in addition to meeting the approval requirements, exercise
            due diligence to drive safely and to maintain the security of the vehicle and its contents. Use of handheld cellphones
            (including texting) while behind the wheel of a moving vehicle being used on company business is strictly prohibited. 
            Employees are responsible for any driving infractions or fines as a result of their driving. </li>
            <li> None employees and nonbusiness passengers (i.e., family and friends) are prohibited from riding in company vehicles. </li>
            <li> Employees must report any accident, theft or malicious damage involving a company vehicle to their supervisor, regardless
            of the extent of damage or lack of injuries. Such reports must be made as soon as possible but no later thatn 24 hours after the incident.
            Employees are expected to cooperate fully with the authorities in the event of an accident. </li>
            <li> Employees are not permitted, under any circumstances, to operate a company vehicle or personal vehicle for company
            business when any physical or mental impairment causes the employee to be unable to drive safely. Additionally, employees
            shall not operate any company vehicle at any time or operate any personal vehicle while on company business while using
            or consuming alcohol, illegal drugs or prescription medications that may affect their ability to drive. These prohibitions
            include circumstances in which the employee is temporarily unable to operate a vehicle safely or legally because of impairment,
            illness, medication or intoxication. </li>
            <li> Employees are only allowed to drive a company car if they have a valid driver's license and a clean driving record for at least
            one year. A clean driving record means the employee has not been held at fault for a car accident or arrested on charges of violating
            vehicle and traffic lawas. THE COMPANY can assign and revoke access company vehicle at its discretion. </li>
            <li> THE COMPANY DOES not allow (unless exception approved) personal use of company vehicles. Personal use
            includes using the vehicle for personal errands between business activities, to commute between workplace and home,
            or using the vehicle outside of business hours. </li>
            <li> Company vehicles are not to be driven off road, on dirt roads or used in any manner that would damage the vehicle </li>
            <li> Do not park the vehicle and keep it on, idle for long periods of time. </li>
            <li> Do keep the vehicle clean. Take any trash out, clothes or food out at the end of the trip. Vacuum if dirty. </li>
            <li> It is required that you fill out a vehicle inspection form before using the vehicle, and again at the end 
            of the trip, before returning the keys. The inspection form needs to be emailed to 
            <a href="Fleet@THECOMPANY.com" target="_blank">Fleet@THECOMPANY.com</a>
            daily. Any incident, malfunction, non-working or broken parts needs to be reported immediately
            in the body text of the email sending the inspection form. </li>
            <li> Do not allow unauthorized drivers to use company vehicles unless required by an emergency. </li>
            <li> Always lock company cars. </li>
            <li>Drivers must have the appropriate state required class of license for the vehicle operated. </li>
            <li> All passengers must be seated and in their seat belts at all times while vehicle is moving. There may not be more passengers must
            in any vehicle than the number of seatbelts in the vehicle. For example, if there are 8 seatbelts, there
            should be only 8 passengers. </li>
            <li> Smoking, eating and drinking anything other than water is prohobited at all times in any of the vehicles. </li>
            <li> Complete the druver's defensive training and return the certificate or email a copy to 
            <a href="Fleet@THECOMPANY.com" target="_blank">Fleet@THECOMPANY.com</a> </li>
            <li> Follow the link to start the training: </li>
            <li> <a href="http://wwww.dgs.ca.gov/orim/Programs/DDTOnlineTraining.aspx" target="_blank">http://wwww.dgs.ca.gov/orim/Programs/DDTOnlineTraining.aspx</a>
 </li>
        </ul>
        </p>
         <div class="text-center text-caption">
          <p class="text-caption">
             <b> Transportation Requirements </b>
          </p>
        </div>
        <p class="text-caption">
          <ul>
            <li> Field employees who transport clients both in company and personal vehicles
            must ensure transportation of clients meets the following requirements: </li>
            <li> All transportation must be done in accordance with all applicable state
            laws (e.g., speed limit, appropriate use of turn signals, etc.). </li>
            <li> Clients are not to be left unattended in the vehicle. </li>
            <li> Clients and employees must use seat belts and remain seated 
            while the vehicle is in motion. </li>
            <li>Keys must be removed from the vehicle at all times if the driver is not in the
            front seat, unless the driver is actively operating a wheelchair lift or ramp that 
            requires the keys to be in the ignition. </li>
            <li>Clients who use a wheelchair must use seat belts or locking mechanisms to
            immobilize and secure the wheelchair during travel. </li>
            <li> If applicable, clients must be transported with safety restraints or harnesses
            in place in accordance with the client's Behavior Support Plan and 
            approved rights restrictions. </li>
            <li>Vehicles used for transporting clients must have working door locks. </li>
            <li> Doors must be locked at all times while a vehicle is in motion. </li>
            <li> Clients must arrive safely at the scheduled time and arranged destination. </li>
            <li> Clients are not to be left alone along the way to or from day supports even in emergency
            situations or when the health and safety of others may be in question. </li>
            <li> If necessary during an emergency, the driver may wait until another driver arrives
            to complete the transport. </li>
            <li> Unless they are actively transporting a client, employees shall not park a company vehicle
            with handicap license plates or a hang tag in a handicap parking space. </li>
            <li> Employees may not, under any circumtance, use a cell phone or other technology for any purpose
            while transporting clients. </li>
            <li> Auto insurance claims for accidents that occur in the personal vehicle of an employee while
            transporting THE COMPANY clients must go through the personal auto insurance of 
            the employee. </li>
          </ul>
        </p>
        <div class="text-center text-caption">
          <p class="text-caption">
             <b> Vehicle Accidents </b>
          </p>
        </div>
        <p class="text-caption">
          <ul>
            <li> If an employee is in a car accident while transporting THE COMPANY clients in their personal 
            vehicle they must immediately inform their direct supervisor and the Human Resources Department and 
            submit a completed Field Occurence Report by the end of the shift during which the accident occured.
            Under the direction of the Human Resources Department, the employee may be subject to drug testing on
            the day of the accident. Any auto insurance claims for accidents that occur in the 
            personal vehicle of an employee while transporting THE COMPANY clients must go through the 
            personal auto insurance of the employee. </li>
            <li> If an employee is in a car accident while driving a compant vehicle (with or without clients) they must
            immediately inform their direct supervisor, the Human Resources Department, and the Fleet Manager and 
            submit a completed Field Occurrence Report by the end of the shift during which the accident 
            occured. Under the direction of the Human Resources Department, the employee may be subject to drug testing
            on the day of the accident. </li>
            <li> If the accident is found to be the fault of the employee, the employee will be responsible for all
            damages and subject of further investigation and possible termination. </li>
          </ul>
        </p>
        <p class="text-caption">
         <b> I have read and understand the Vehicle Policy  </b>
        </p>

        
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignature"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSigned"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSigned"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        <p class="text-caption">
         <b> I have completed the Defensive Drivers Training:   </b>
        </p>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="trainingSignature"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSignedTraining"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSignedTraining"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      employeeSignature: "",
      trainingSignature: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignature = data;
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
          signedDate: moment(documents.signedDate).format("YYYY-MM-DD"),
          dateSigned: moment(documents.dateSigned).format("YYYY-MM-DD"),
          dateSignedTraining: moment(documents.dateSigned).format("YYYY-MM-DD"),
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
